export default __webpack_public_path__ + "static/media/factor_item_3.6b99e439.png";